import { render, staticRenderFns } from "./AsiaVhisCancelPolicy.vue?vue&type=template&id=6adc94f9"
import script from "./AsiaVhisCancelPolicy.vue?vue&type=script&lang=js"
export * from "./AsiaVhisCancelPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports